import { useEffect } from 'react'
import { LocationSelect, EventSearch } from 'search'
import { useLocation } from 'react-router'

import Tabs, { Tab } from 'shared/components/Tabs'
import {
    SEARCH_MODE_EVENTS,
    SEARCH_MODE_MONTHLY,
    BOOKABLE_SEASON_TICKET_ONLY,
    SEARCH_MODE_AIRPORTS,
    SEARCH_MODE_HOURLY,
} from 'search/constants'
import featureToggles from 'shared/featureToggles'
import { isBrazilNeo } from 'shared/country'
import Icon from 'shared/components/Icon'

import { getInitSearchMode } from 'map/helpers'

const TABS = [
    featureToggles.hasAirportFlow && {
        label: 'input.tab.search.airports',
        mode: SEARCH_MODE_AIRPORTS,
        children: <></>,
    },
    {
        label: 'input.tab.search.park',
        mode: getInitSearchMode(window.COUNTRY),
        children: (
            <LocationSelect
                placeholder={<T>input.placeholder.search.park</T>}
                size="large"
                icon="pin-indigo-bookable-act"
            />
        ),
    },
    featureToggles.hasEventFlow && {
        label: 'input.tab.search.event',
        mode: SEARCH_MODE_EVENTS,
        children: <EventSearch size="large" icon="ticket" />,
    },
    {
        label: 'input.tab.search.subscription',
        mode: SEARCH_MODE_MONTHLY,
        children: (
            <LocationSelect
                placeholder={<T>input.placeholder.search.subscription</T>}
                size="large"
                icon="pin-indigo-bookable-act"
                bookableMode={BOOKABLE_SEASON_TICKET_ONLY}
            />
        ),
    },
]

//Brazil neo requires different order of tabs. The logic may have to be gone over at some point.
if (isBrazilNeo && featureToggles.hasEventFlow) {
    ;[TABS[2], TABS[3]] = [TABS[3], TABS[2]]
}

const getActiveTab = parkingMode => {
    const index = TABS.findIndex(({ mode }) => parkingMode === mode)
    return featureToggles.caPurchaseFlow && !featureToggles.hasAirportFlow ? index - 1 : index
}

const Search = ({ setParkingMode, parkingMode }) => {
    const { hash } = useLocation()
    const activeTab = hash !== '' ? getActiveTab(parkingMode) : getActiveTab(SEARCH_MODE_HOURLY)

    useEffect(() => {
        hash === '' ? setParkingMode(SEARCH_MODE_HOURLY) : setParkingMode(hash.replace('#', ''))
    }, [])

    return (
        <Tabs tabStyle="tabs" activeTab={activeTab}>
            {TABS.filter(tab => Boolean(tab)).map(({ mode, label, children }) => (
                <Tab
                    key={mode}
                    label={<T>{label}</T>}
                    icon={mode === SEARCH_MODE_AIRPORTS && <Icon type={'arrow-forward'} size={'xxs'} />}
                    onClick={() => setParkingMode(mode)}>
                    {children}
                </Tab>
            ))}
        </Tabs>
    )
}

export default Search
